<template>
    <div class="container" v-loading="tableing">
        <div class="header">
            <el-button class="exit" size="mini" @click="exit()"> 退出 </el-button>
        </div>
        <div class="main">
            <div class="welcome">
                <table border="0">
                    <tr><td style="textAlign: left;"><b>亲爱的同学：</b></td></tr>
                    <tr><td style="textAlign: left;">你好！</td></tr>
                    <tr><td style="textAlign: left;">&nbsp;</td></tr>
                    <tr><td style="textAlign: left;">感谢你在繁忙的学业中参加国家义务教育课程方案与标准修订测试。</td></tr>
                    <tr><td style="textAlign: left;">国家课程方案与标准是你们在学校中使用的所有课本的编写依据，也是老师教学工作和考试评价的依据。</td></tr>
                    <tr><td style="textAlign: left;">它关系中小学教育质量的提升。你的认真作答对更好地制定课程标准具有很大的作用。</td></tr>
                    <tr><td style="textAlign: left;">非常感谢你的参加！祝你身体健康，学业进步！</td></tr>
                    <tr><td style="textAlign: left;">&nbsp;</td></tr>
                    <tr><td style="textAlign: right;">教育部基础教育课程教材发展中心</td></tr>
                    <tr><td style="textAlign: right;">{{new Date(timestamp2).getFullYear()}}年{{new Date(timestamp2).getMonth()+1}}月</td></tr>
                </table>
            </div>
        </div>
        <div class="goExamBox">
            <el-button class="upSub" @click="lastQuestion()"> 下一步 </el-button>
        </div>

        <audio ref="dearStudent" :src="tockUrl" id="dearStudent" v-show="false"></audio>

    </div>
</template>
<script>
import recording from '../../lib/recording'
import audioStyle from '../../components/audioStyle'
import os from '../../lib/oss'
    export default {
        name:"chooseOrg",
        data() {
            return {
                tableing:false,
                list:[],
                tockUrl:require('../../../static/music/dearStudent.aac'),
                timeLz:0,
                interval: '',
                timestamp2:0,
            }
        },
        components:{
            audioStyle
        },
        watch: {},
        computed:{},
        created(){},
        mounted(){
            let that = this
            that.getTimeNet()
            that.$nextTick(()=>{
                setTimeout(function(){
                    that.$refs.dearStudent.play()
                },0)
            })
        },
        methods:{
            goCheck(){
                let that = this
                let audio_player = document.querySelector('audio#dearStudent');
                if(!audio_player.paused){
                    audio_player.pause();
                }
                audio_player.currentTime = 0;
            },
            lastQuestion(){
               this.$router.push({
                    path: '/mkfDetection',
                    query: {
                        bId:this.$route.query.bId,
                        paperName:this.$route.query.paperName,
                        userSignId:this.$route.query.userSignId,
                        ticketNum:this.$route.query.ticketNum,
                        idName:this.$route.query.idName,
                        idCardNo:this.$route.query.idCardNo,
                    }
                }) 
            },
            exit(){
                this.$router.push({
                    path: '/myExamList'
                })
            },
            getTimeNet(){
                let poorTime = window.localStorage.getItem('poorVal')
                this.timestamp2 = Date.parse(new Date());
                if(Number(poorTime)>=0){this.timestamp2 = Number(this.timestamp2) + Number(poorTime)}
                else{this.timestamp2 = Number(this.timestamp2) - Number(Math.abs(poorTime))}
            }
        }
    }
</script>
<style scoped lang="less">
    .container{
        width: 100%;
        height: 100%;
        position: relative;
    }
    .header{
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        height: 60px;
        line-height: 60px;
        text-align: center;
        font-size: 19px;
        font-weight: bold;
        color: #000;
        border-bottom: 1px solid #EDEEED;
        .exit{
            background-color: #31C4FE;
            border: none;
            font-size: 15px;
            width: 74px;
            height: 32px;
            color: #fff;
            position: absolute;
            top: 15px;
            right: 3%;
            img{
                height: 10px;
            }
        }
    }
    .main{
        position: absolute;
        top: 75px;
        bottom: 20%;
        left: 0;
        right: 0;
        width: 100%;
        .welcome{
            width: 86%;
            height: 75%;
            margin-left:7%;
            table{
                width: 100%;
                height: 90%;
                td{
                    font-size: 18px;
                    font-weight: 500;
                    padding: 0.45% 0;
                }
            }
        }
        
    }
    .goExamBox{
        position: absolute;
        left: 0;
        right: 0;
        top: 80%;
        bottom: 0;
        height: 20%;
        width: 100%;
        .upSub{
            position: absolute;
            left: 0;
            top: 0;
            right: 0;
            bottom: 0;
            margin: auto;
            height: 45px;
            width: 35%;
            background: rgb(0, 75, 180);
            color: #FFF;
            border-radius: 3px;
            font-size: 18px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/pages/myExamList/tapeTest.vue